import { ENDPOINT, axios } from "./constants"

export default class ApiAuthorizedSignature {
  static async get() {
    const query = `
        query {
            allAuthorizedSignatureImpl {
                idAuthorizedSignature
                name
                position
            }
        }`

    const response = await axios.post(ENDPOINT.QUERY, { query })

    return { data: response.data.data.allAuthorizedSignatureImpl }
  }

  static async create({ name, position = null }) {
    const query = `
    mutation ($signature: AuthorizedSignatureInput!) {
      saveAuthorizedSignatureImpl(authorizedSignature: $signature) {
        authorizedSignatureImpl {
          idAuthorizedSignature
          name
          position
        }
      }
    }`
    const variables = { signature: { name, position } }
    const res = await axios.post(ENDPOINT.CREATE, { query, variables })
    // optional: log error BE biar cepat debug
    console.log(res.data?.errors?.[0]?.message)
    if (res.data?.errors) console.error("GQL errors:", res.data.errors)
    return {
      data:
        res.data?.data?.saveAuthorizedSignatureImpl?.authorizedSignatureImpl,
    }
  }
}
